import React, { useState } from 'react';
import { PdfThumbnail, PageNumberLabel } from './styles';
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import { updatePdfPage } from '@services';
import { setPdfPage } from '@actions/creators';
import { setBrowserStorageItem } from '@utils/browserStorage';
import { BROWSER_STORAGE_KEYS } from '@constants';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const PdfList = ({ pdfUrl, pageHeight, dispatch }) => {
    const { pdfPageKey } = BROWSER_STORAGE_KEYS;
    const [numPages, setNumPages] = useState(null);
    const [error, setError] = useState({
        status: false,
        message: ''
    });
  
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function onDocumentLoadError(err) {
        console.error(err);
        setError({ status: true, message: err.message });
    }

    if (error.status) return (
        <div>Error loading pdf: {error.message}</div>
    );

    const selectPdfPage = (pageNum) => {
        dispatch(setPdfPage(pageNum));
        updatePdfPage(pageNum);
        setBrowserStorageItem(pdfPageKey, pageNum);
    };

    return (
        <Document
            file={pdfUrl}
            onLoadError={onDocumentLoadError}
            onLoadSuccess={onDocumentLoadSuccess}>
            {
                Array.from(
                    new Array(numPages),
                    (el, index) => (
                    <React.Fragment key={`page_${index + 1}`}>
                        <PdfThumbnail
                            pageHeight={pageHeight}
                            onClick={() => selectPdfPage(index + 1)}>
                            <Page
                                data-testid='pdf-page'
                                pageNumber={index + 1}
                            />
                        </PdfThumbnail>
                        <PageNumberLabel>
                            Page {index + 1}/{numPages}
                        </PageNumberLabel>
                    </React.Fragment>
                    )
                )
            }
        </Document>
    );
};

export default PdfList;
